import React, { useContext, useRef } from 'react';
import { Platform, StyleSheet, Text } from 'react-native';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';
import { useOverflowStyle } from '../../hooks/useOverflowStyle';

const H4 = ({ numberOfLines = 1, style, text, ...rest }) => {
    const { layout } = useContext(LayoutContext);
    const ref = useRef();
    const overflowStyle = useOverflowStyle(ref, layout.styleGuide.h4);

    return (
        <Text
            {...rest}
            adjustsFontSizeToFit={true}
            dataSet={{
                tagName: 'H4',
                fontFamily: layout.styleGuide.h4.fontFamily,
                condensedFontFamily: layout.styleGuide.h4.condensedFontFamily,
                fontSize: layout.styleGuide.h4.fontSize,
                color: layout.styleGuide.h4.color
            }}
            numberOfLines={numberOfLines}
            ref={ref}
            style={StyleSheet.flatten([Style.h4, layout.styleGuide.h4, overflowStyle, style])}
        >
            {text}
        </Text>
    );
};

const Style = StyleSheet.create({
    h4: {
        color: '#000',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '16pt' : 16
    }
});

H4.propTypes = {
    numberOfLines: PropTypes.number,
    text: PropTypes.string.isRequired
};

export default H4;
